import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-faq-shown-component',
  templateUrl: './no-faq-shown-component.component.html',
  styleUrls: ['./no-faq-shown-component.component.scss']
})
export class NoFaqShownComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
